const getters = {
  getConfigurationFilters(state) {
    return state.configurationFilters;
  },
  getAchievementClubbingData(state) {
    return state.achievmentClubbingData;
  },
  getProDataSetupData(state) {
    return state.proDataSetupData;
  },
  getBranchOptions(state){
    return state.branchDropdownOptions;
  },
  getJobLists(state){
    return state.jobLists;
  },
  getGroupTypeLists(state){
    return state.groupTypeLists;
  },
  getShipToCodeForCcnPrefDats(state){
    return state.ShipToCodeForCcnPrefData;
  },
};

export default getters;
